module.exports = __webpack_public_path__ + "static/media/design4.80bb25bc.jpg";